import { Icon } from '../../components/Icon.tsx';
import { products } from './products.ts';

/**
 * The suite at a glance, directly under the hero — so you know what Wapplify
 * Office contains before scrolling through the full sections.
 *
 * Three columns of plain type: a teal glyph, the name, one line. No cards, no
 * fills, no borders — the columns are held apart by space alone, and the only
 * colour is the icon and the arrow.
 *
 * Copy is reused from products.ts; the heading is the word the Applications
 * page already uses.
 */
export function AppIndex(): JSX.Element {
  return (
    <section className="folio-wide py-20 sm:py-28">
      <div className="reveal max-w-2xl">
        <span className="chip-dv">އެޕްލިކޭޝަންތައް</span>
        {/* Verbatim from the hero eyebrow — no invented Dhivehi anywhere on
            this page; every string already existed in the codebase. */}
        <h2 className="head-dv mt-3 text-[1.9rem] leading-[1.35] sm:text-[2.4rem] sm:leading-[1.3]">
          ލޯކަލް ކައުންސިލްތަކުގެ އޮފީސް ސުއިޓް
        </h2>
      </div>

      <ul className="mt-14 grid grid-cols-1 gap-x-14 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
        {products.map((p, i) => (
          <li
            key={p.key}
            className="reveal"
            style={{ '--reveal-delay': `${70 * i}ms` } as React.CSSProperties}
          >
            <a href={`#${p.key}`} className="group block">
              <Icon name={p.icon} size={30} className="text-[hsl(var(--primary))]" />

              <h3 className="head-dv mt-4 flex flex-wrap items-center gap-2 text-2xl leading-tight">
                {p.name}
                {p.inDevelopment && (
                  <span className="chip-warn">
                    <span className="head-dv leading-none">ޑިވެލޮޕްކުރަމުން ދަނީ</span>
                  </span>
                )}
              </h3>

              <p className="mt-3 leading-loose text-muted-foreground">{p.tagline}</p>

              <span className="mt-4 inline-flex text-[hsl(var(--primary))]">
                <Icon
                  name="arrow_back"
                  size={20}
                  className="transition-transform group-hover:-translate-x-1"
                />
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
